module.exports = __webpack_public_path__ + "static/media/8.ccf2b5a2.jpg";